module.exports = __webpack_public_path__ + "static/ogw2-mini-37561e94d59847fbd85c4a2855dffa2c.jpg";